import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import DefaultInput from "../../inputs/defaultInput";
import Loading from "../../skeleton/loading";
import DefaultButton from "../../buttons/defaultButton";
import { _updateDepartment } from "../../../../store/slices/baseSetup.slice";
import { _fetchDepartments } from "../../../../store/actions/configuration";
import { useDispatch, useSelector } from "react-redux";
import DragAndDropFile from "../../inputs/simpleFileUploader";
import { _extractFileDetails } from "../../../../utils/common";
import { _setFiles } from "../../../../store/slices/global.slice";
// Note: createFeeReceiptPayment import removed as fees.service is not available for HR management system

const validationSchema = Yup.object().shape({
  id: Yup.string().required("Transaction ID / Receipt ID is required"),
  documents: Yup.array()
    .of(Yup.object().required("Documents is required"))
    .min(1, "Documents is required"),
});

const AddCashForm = ({
  handleRefresh = () => null,
  setSelected = () => null,
  isModal = false,
  data = null,
  onClose = () => null,
  id,
  selected = [],
}) => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { fileLoading } = useSelector((state) => state.global);

  useEffect(() => {
    dispatch(_setFiles([]));
  }, []);

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormik({
    initialValues: {
      id: "",
      documents: [],
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      const payload = {
        user_id: data?.user_id,
        id: values.id,
        documents: _extractFileDetails(values?.documents),
        items: selected.map((item) => item.id),
      };
      setIsSubmitting(true);

      // Note: createFeeReceiptPayment removed as fees.service is not available for HR management system
      toast.error("Fee payment functionality is not available in HR management system");
      setIsSubmitting(false);
      setSelected([]);
      if (isModal) {
        onClose();
        handleRefresh();
      }
    },
  });

  return (
    <Fragment>
      {loading ? (
        <Loading />
      ) : (
        <div className={"flex flex-col w-full gap-4 bg-white rounded-md"}>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className={"flex flex-col gap-4 gap-y-2"}>
              <DefaultInput
                label={"Transaction ID / Receipt ID"}
                name="id"
                value={values.id}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.id && errors.id ? errors.id : ""}
                required
              />
              <div className="col-span-2">
                <DragAndDropFile
                  label={"Upload Document"}
                  onChange={(files) => {
                    setFieldValue("documents", files);
                  }}
                  name={"documents"}
                  limit={1}
                  error={
                    touched.documents && errors.documents
                      ? errors.documents
                      : ""
                  }
                  required
                />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <DefaultButton
                variant="default"
                name={id ? "Edit" : "Submit"}
                type="submit"
                disabled={fileLoading || isSubmitting}
                loading={isSubmitting}
                onClick={handleSubmit}
              />
              {isModal ? (
                <DefaultButton
                  variant="secondary"
                  name={"Cancel"}
                  onClick={onClose}
                />
              ) : null}
            </div>
          </form>
        </div>
      )}
    </Fragment>
  );
};

export default AddCashForm;
